'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _documentHeader = require('./document-header');

var _documentHeader2 = _interopRequireDefault(_documentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Space = _jsx('u', {}, void 0, ' '.repeat(10));
var DocumentBody = _jsx('div', {
  className: 'm-document-body'
}, void 0, _jsx('h1', {}, void 0, 'NON-DISCLOSURE AGREEMENT'), _jsx('p', {}, void 0, 'THIS AGREEMENT (the "Agreement") is entered into on this', Space, ' day of ', Space, ' by and between ', Space, ', located at', Space, ' (the "Disclosing Party"), and ', Space, ' with and address at ', Space, ' (the "Recipient" or the "Receiving Party").'), _jsx('p', {}, void 0, 'The Recipient hereto desires to participate in discussions regarding ', Space, ' (the "Transaction"). During these discussions, Disclosing Party may share certain proprietary information with the Recipient. Therefore, in consideration of the mutual promises and covenants contained in this Agreement, and other good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the parties hereto agree as follows:'));

module.exports = function (_React$Component) {
  _inherits(DocumentUI, _React$Component);

  function DocumentUI() {
    _classCallCheck(this, DocumentUI);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(DocumentUI).apply(this, arguments));
  }

  _createClass(DocumentUI, [{
    key: 'render',
    value: function render() {
      return _jsx('section', {
        className: 'm-document-container'
      }, void 0, _jsx('h2', {}, void 0, _jsx('img', {
        src: require('./assets/1.png')
      }), _jsx('span', {}, void 0, 'First, select an area or text below.'), _jsx('img', {
        src: require('./assets/arrow_1.png'),
        className: 'arrow-1'
      })), _jsx('div', {
        className: 'm-document'
      }, void 0, _jsx('div', {
        className: 'm-document-inner'
      }, void 0, _react2['default'].createElement(_documentHeader2['default'], this.props), DocumentBody)));
    }
  }]);

  return DocumentUI;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/document-ui.jsx
 ** module id = 871
 ** module chunks = 0
 **/